import { AxiosError } from 'axios';
import { notification } from 'ant-design-vue';
import i18n from '@/i18n';
import Vue from 'vue';

/**
 * Show error notifications from given error
 * @param error - The error that occurred
 */
export function showErrorNotifications(error: AxiosError, duration = 5) {
    if (error.response == null) {
        const errorMessage = (error as Error).message;

        // Check if message contains HTML with onclick for clickable help icon
        if (errorMessage.includes('onclick=')) {
            notification.error({
                message: i18n.t('Dogodila se greška') as string,
                description: (h: any) => h('div', { domProps: { innerHTML: errorMessage } }),
                duration: 0, // Don't auto-dismiss
            });
            return;
        }

        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: errorMessage,
            duration,
        });
        return;
    }

    error.response.data.errors.forEach(({ detail }: { detail: string }) => {
        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: detail,
            duration,
        });
    });
}

/**
 * Show the successful change notification
 */
export function showChangeSuccessNotification() {
    notification.success({
        message: i18n.t('Promjena uspješna!') as string,
        description: '',
    });
}
